<div (dragover)="onDragOver($event)" (dragleave)="onDragLeave()" (drop)="onDrop($event)"
  [style.border]="dragging ? '2px dashed #1C593D' : '2px dashed #bbf7d0'"
  [style.background]="dragging ? '#f0fdf4' : 'white'"
  style="border-radius: 12px; padding: 16px; text-align: center; transition: all 0.2s ease; cursor: pointer;"
  (click)="fileInput.click()">

  <input #fileInput type="file" multiple accept=".png,.jpg,.jpeg,.gif,.wav,.mp3,.mp4,.mov,.avi,.wmv,.doc,.docx,.ppt,.xls,.xlsx,.pdf"
    style="display: none;" (change)="onFileSelect($event)">

  <mat-icon style="font-size: 24px; width: 24px; height: 24px; color: #9ca3af;" *ngIf="!uploading">cloud_upload</mat-icon>
  <mat-spinner *ngIf="uploading" diameter="24" style="margin: 0 auto;"></mat-spinner>

  <p style="font-size: 0.8rem; color: #6b7280; margin-top: 4px;">
    {{ uploading ? 'Subiendo...' : 'Adjuntar archivos (máx. ' + maxFiles + ')' }}
  </p>
</div>

<div *ngIf="files.length" style="margin-top: 8px; display: flex; flex-direction: column; gap: 6px;">
  <div *ngFor="let f of files; let i = index"
    style="display: flex; align-items: center; gap: 8px; background: #f0fdf4; border: 1px solid #bbf7d0; border-radius: 8px; padding: 8px 12px;">
    <mat-icon style="font-size: 16px; width: 16px; height: 16px; color: #1C593D;">attach_file</mat-icon>
    <span style="flex: 1; font-size: 0.78rem; color: #374151; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">{{ f.fileName }}</span>
    <button type="button" (click)="removeFile(i)" title="Eliminar"
      style="display: inline-flex; align-items: center; justify-content: center; width: 24px; height: 24px; background: #fef2f2; border: 1px solid #fecaca; border-radius: 4px; cursor: pointer;">
      <mat-icon style="font-size: 14px; width: 14px; height: 14px; color: #dc2626;">close</mat-icon>
    </button>
  </div>
</div>
